
import { useQuery } from "react-query";
import axios from "axios";
import { useEffect, useState } from "react";
import "./registerconfirm.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint } from "../components/utils";
import { pageIds } from "../components/utils";
import { getUserInfo, logoutUser } from "../components/user";
import { Link } from "react-router-dom";


interface PageResponse {
  headerTitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  welcomeMessage?: any;
}

const RegisterConfirm = () => {
  const [data, setdata] = useState<PageResponse | null>();
  const userData = getUserInfo();
  const { isLoading, error } = useQuery("registerPageData", async () => {
    const resp = await axios.get(ApiEndpoint + "wp-json/satapp-api/v1/getPageText?slug=" + pageIds.register_confirm);
    setdata(resp.data as PageResponse);
  });

  useEffect(() => { 
    if (userData?.userType !== 0) logoutUser();
  }, []);

  if (isLoading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <div className="registerConfirmPage">
        <div className="headline">
            <h1>{data?.headerTitle}</h1>
            {userData?.userType === 0 
              ?
              <div className="description">Thank you for finishing your registration. You may now visit your dashboard. <Link to={'/dashboard'}>Dashboard</Link></div>

              :
              <div className="description" dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }} />
            }
        </div>
    </div>
    );
};

export default RegisterConfirm;
